import React, { useEffect, useState, ReactNode } from 'react'
import Text from '../../atoms/Text/Text'

interface MobileDetectionWrapperProps {
  children: ReactNode
}

// Mobile detection wrapper component
export const MobileDetectionWrapper: React.FC<MobileDetectionWrapperProps> = ({ children }) => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    // Function to detect mobile devices
    const checkIfMobile = (): void => {
      // Check for common mobile user agents
      const mobileRegex = /Android|webOS|iPhone|iPad/i
      const isMobileUserAgent = mobileRegex.test(navigator.userAgent)

      // Also check screen width as a backup method
      const isMobileWidth = window.innerWidth <= 1024

      setIsMobile(isMobileUserAgent || isMobileWidth)
    }

    // Check on initial render
    checkIfMobile()

    // Add resize listener to handle orientation changes
    window.addEventListener('resize', checkIfMobile)

    // Clean up event listener
    return () => window.removeEventListener('resize', checkIfMobile)
  }, [])

  // If not mobile, render the normal content
  if (!isMobile) {
    return <>{children}</>
  }

  return (
    <div data-testid='mobile-restriction-container' className='bg-black flex justify-center items-center min-h-screen w-full p-4'>
      <div className='glow-effect max-w-md w-full'>
        <div className='diamond-corner p-1 bg-dopage-lightGreen w-full'>
          <div className='inner bg-black'>
            <div className='py-8 px-4 flex flex-col justify-center items-center text-dopage-darkGreen'>
              <h2 data-testid='mobile-restriction-title' className='text-xl md:text-2xl font-bold mb-6 w-full text-center'>
                <Text
                  className='font-bold text-center w-full'
                  bold
                  size='LG'
                  text='Grab your computer!'
                />
              </h2>
              <p data-testid='mobile-restriction-message' className='text-base md:text-xl text-center text-dopage-lightGreen mb-4 w-full'>
                <Text
                  className='text-center w-full'
                  size='SM'
                  text='The DopaGE Overdose Prevention Portal is not accessible via mobile device. Please sign in from a laptop or desktop computer.'
                />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
